import { Icon } from "@/components/icons/Icon";
import { DropdownMenu, DropdownMenuItem } from "@/components/interactive/DropdownMenu";
import { classNames } from "@/utils/classnames";
import { useRouteInfo } from "@/utils/hooks/url/use-route-info";
import { useSession } from "next-auth/react";
import { signOutAndResetAnalytics } from "@/utils/sign-out";
import { Routes } from "utils/routes";

export function ProfileDropdown() {
  const { projectId, environmentId } = useRouteInfo();
  const user = useSession().data?.user;

  return (
    <DropdownMenu
      floatOptions={{ placement: "bottom-end" }}
      className="ml-3"
      renderButton={(r) => (
        <span
          ref={r}
          className={classNames(
            "bg-white rounded-full flex flex-row text-cds-sm overflow-hidden transition-transform duration-75 cursor-pointer items-start",
            "hover:scale-105 active:scale-110",
            "focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
          )}
        >
          <span className="sr-only">Open user menu</span>
          {user?.image ? (
            <img
              referrerPolicy="no-referrer"
              src={user.image}
              height={24}
              width={24}
              alt={"user profile"}
            />
          ) : (
            <Icon name="user" className={"text-cds-text-secondary"} />
          )}
        </span>
      )}
    >
      {user && (
        <DropdownMenuItem
          disabled
          className="border-b"
          // href={Routes.profile}
        >
          <div className="flex flex-col text-xs ">
            <span className="truncate">{user.name}</span>
            <span className="text-zinc-400 truncate">{user.email}</span>
          </div>
        </DropdownMenuItem>
      )}
      {projectId && environmentId && (
        <DropdownMenuItem
          href={Routes.project.environment.settings(projectId, environmentId)}
          icon={"settings"}
        >
          Settings
        </DropdownMenuItem>
      )}
      <DropdownMenuItem
        onClick={async () => {
          await signOutAndResetAnalytics({ callbackUrl: Routes.login });
        }}
        icon={"logOut"}
      >
        Sign out
      </DropdownMenuItem>
    </DropdownMenu>
  );
}
